//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminObligationController_findAll,
  Response$AdminObligationController_findAll$Status$200,
  ResponseContentType$AdminObligationController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminObligationController_findAll = (options: {
  params: Params$AdminObligationController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminObligationController_findAll$Status$200[ResponseContentType$AdminObligationController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminObligationController_findAll,
    Response$AdminObligationController_findAll$Status$200[ResponseContentType$AdminObligationController_findAll]
  >({
    method: 'AdminObligationController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
